import {
  Box,
  BoxProps,
  Image,
  Heading,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import qrCode from '../images/qr-code-location.webp';

const WeddingDetails: React.FC = () => {
  return (
    <Box alignContent="center" textAlign="center" color="white" py={12} px={4}>
      <Box mb={14}>
        <Text fontSize="2xl">THE CEREMONY</Text>
        <Text fontSize="xs" mt={2}>
          3:30 PM, 21 October 2025
          <br />
          <strong>AQUILA CRYSTAL PALACE</strong>
          <br />
          #328 BRGY. MAITIM 2ND ST.
          <br />
          E. AGUINALDO HIGHWAY,
          <br />
          TAGAYTAY, 4120 CAVITE, PHILIPPINES
        </Text>
        <Text fontSize="xs" fontWeight="bold" fontStyle="italic" mt={2} mb={2}>
          formal / semi formal attire
        </Text>
        <Link
          href="https://maps.app.goo.gl/V651x8ZtwsxhM65d7"
          target="_blank"
          textTransform="uppercase"
          letterSpacing="3px"
          color="#ffffff"
          fontSize={['sm', 'md']}
          textDecor="none"
        >
          <Image
            src={qrCode}
            alt="Keshawa & Carrie are getting married."
            h="100px"
            w="auto"
            m="auto"
          />
        </Link>
        <Text fontSize="2xs">SCAN or CLICK FOR DIRECTIONS</Text>
      </Box>
      <Box mb={14}>
        <Text fontSize="2xl">COCKTAIL HOUR</Text>
        <Text fontSize="xs" mt={2}>
          SMILES, SIPS, AND BITES
          <br />
          FOUR IN THE AFTERNOON
          <br />
          IN THE GARDEN
        </Text>
        <Text fontSize="xs" fontWeight="bold" fontStyle="italic" mt={2}>
          bring your best smile and appetite
        </Text>
      </Box>
      <Box mb={14}>
        <Text fontSize="2xl">DINNER AND DANCING</Text>
        <Text fontSize="xs" mt={2}>
          A CELEBRATION OF LOVE, LAUGHTER, AND TOASTS
          <br />
          FIVE IN THE AFTERNOON
          <br />
          UNDER THE TENT
        </Text>
        <Text fontSize="xs" fontWeight="bold" fontStyle="italic" mt={2}>
          let the evening unfold in joy
        </Text>
      </Box>

      <Box mb={14}>
        <Text fontSize="2xl">THE AFTER PARTY</Text>
        <Text fontSize="xs" mt={2}>
          LATE-NIGHT LAUGHS AND DANCEFLOOR VIBES
          <br />
          EIGHT IN THE EVENING UNTIL LATE
          <br />
          UNDER THE TENT
        </Text>
        <Text fontSize="xs" fontWeight="bold" fontStyle="italic" mt={2}>
          the night’s not over ’til it is
        </Text>
      </Box>
    </Box>
  );
};

export default WeddingDetails;
